import { Button } from 'blaze-ui/Button'
import { Text } from 'blaze-ui/Text/Text'
import { Plus } from 'blaze-ui/icons'
import Styles from '../MetaAdsAccountSetupModal.module.scss'
import { AdAccountCard } from './AdAccountCard'
import { MetaAdsAdAccountSelectProps } from './Types'
import { openWindowSafely } from 'hooks/useOpenWindowSafely'

const CreateNewAccountCard = ({ onPress }: { onPress: () => void }) => (
  <div className={Styles.card}>
    <div className={Styles.cardLeft}>
      <Button variant="ghost" size="lg" frontIcon={Plus} onPress={onPress}>
        Create New Ad Account
      </Button>
    </div>
  </div>
)

export const MetaAdsAdAccountSelect = (props: MetaAdsAdAccountSelectProps) => {
  const { selectedAccountId, onSelectAccount } = props

  const handleCreateNewAccount = () => {
    openWindowSafely('https://business.facebook.com/')
  }

  return (
    <div className={Styles.setupContainer}>
      <div className={Styles.section}>
        <Text variant="secondary">
          Select the Facebook ad account you want to use to run your ads. If you don't have an ad account, you can
          create one by clicking the button below.
        </Text>
      </div>

      <div className={Styles.section}>
        {props.adAccounts.map((account) => (
          <AdAccountCard
            key={account.provider_id}
            account={account}
            isSelected={selectedAccountId === account.provider_id}
            onSelect={() => onSelectAccount(account.provider_id)}
          />
        ))}

        <CreateNewAccountCard onPress={handleCreateNewAccount} />
      </div>

      <div className={Styles.section}>
        <Text variant="secondary">
          Don't see your Facebook Ad Account listed? Make sure you've linked your ad account with Blaze by clicking
          below. If you still don't see it, you may need to create a new ad account.
        </Text>
        <Button variant="tertiary" size="lg" onPress={handleCreateNewAccount}>
          Link Ad Account to Blaze
        </Button>
      </div>
    </div>
  )
}
